import React from 'react'
import clsx from 'clsx'
import Typography from '@mui/material/Typography'
import TollIcon from '@mui/icons-material/Toll'
import Tooltip from 'components/Tooltip'
import { UserImage } from 'models/ApiModels'

const CLASSNAMES = {
  Published: 'absolute right-0 top-0 block z-1 p-1',
  Enhanced:
    'absolute bottom-0 left-0 z-1 block w-full px-3 py-0.5 text-center bg-secondary text-black'
}

export const PublishedStatus: React.FC<{
  className?: string
  userImage?: UserImage
}> = ({ className, userImage }) => {
  const published = userImage?.adjustData?.output?.is_published ?? userImage?.is_published

  if (!published) return null

  return (
    <Tooltip
      className={clsx(CLASSNAMES.Published, className)}
      title={<Typography variant="caption">This image has been published as an NFT </Typography>}
      placement="bottom-start"
    >
      <span>
        <TollIcon className="block" color="secondary" />
      </span>
    </Tooltip>
  )
}

export const EnhancedStatus: React.FC<{ enhanced?: boolean }> = props => {
  const { enhanced } = props

  if (!enhanced) return null

  return (
    <span className={CLASSNAMES.Enhanced}>
      <Typography variant="body2">ENHANCED</Typography>
    </span>
  )
}
